import { render, staticRenderFns } from "./pbbg.vue?vue&type=template&id=6c924250&scoped=true&"
import script from "./pbbg.vue?vue&type=script&lang=js&"
export * from "./pbbg.vue?vue&type=script&lang=js&"
import style0 from "./pbbg.vue?vue&type=style&index=0&id=6c924250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c924250",
  null
  
)

export default component.exports